import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const faqs = [
  { q: 'q1', a: 'a1' },
  { q: 'q2', a: 'a2' },
  { q: 'q3', a: 'a3' },
  { q: 'q4', a: 'a4' },
  { q: 'q5', a: 'a5' },
];

export default function Faq() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100">
      <div className="mx-auto max-w-3xl px-4 md:px-6 py-14 md:py-20">
        <div className="text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">{t('faq.title')}</h2>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q} className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="text-sm md:text-base font-semibold text-foreground-900">{t(`faq.${item.q}`)}</span>
                  <i
                    className={`ri-add-line text-foreground-500 w-5 h-5 flex items-center justify-center transition-transform ${isOpen ? 'rotate-45' : ''}`}
                  />
                </button>
                {isOpen && (
                  <div className="px-5 pb-4">
                    <p className="text-sm leading-relaxed text-foreground-600">{t(`faq.${item.a}`)}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}